import React, { useEffect, useState } from "react";
import classNames from "classnames";
import { DropdownProps } from "./PropsType";
import FadeInZoom from "../Transitions/FadeInZoom";
import { clickOutside } from "../common/Dom";

export default function Dropdown(props: DropdownProps) {
  const {
    children,
    className,
    hover,
    data = [],
    direction = "bottom-left",
    prefixCls = "bm-Dropdown",
  }: any = props;
  const [visible, setVisible] = useState(false);
  const styleClass = classNames(className, prefixCls, {
    [`${prefixCls}-expanded`]: visible,
    [`${prefixCls}-hover`]: hover,
  });
  const menuClass = classNames(
    `${prefixCls}-menu`,
    `${prefixCls}-${direction}`
  );
  let selfClick = false;

  const handleDocumentClick = (event) => {
    if (visible) {
      clickOutside(
        event.target,
        prefixCls!,
        () => {
          selfClick = true;
        },
        () => {
          selfClick = false;
          setVisible(false);
        }
      );
    }
  };

  const handleMouseLeave = () => {
    if (props.hover) {
      setVisible(false);
    }
  };

  const handleMouseover = () => {
    if (props.hover) {
      setVisible(true);
    }
  };

  const itemClick = (item) => {
    setVisible(false);
    if (item.onClick) {
      item.onClick();
    }
  };

  const toggle = () => {
    if (!props.hover) {
      setVisible(!visible);
    }
  };

//   const close = () => {
//     setVisible(false);
//   };

//   const onClickoutside = () => {
//     if (!props.hover) {
//       close();
//     }
//   };

  useEffect(() => {
    document.addEventListener("click", handleDocumentClick);

    return () => {
      document.removeEventListener("click", handleDocumentClick);
    };
  }, []);

  return (
    <div className={styleClass} onMouseLeave={handleMouseLeave}>
      <div
        className={`${prefixCls}-header`}
        onMouseOver={handleMouseover}
        onClick={toggle}
      >
        {children}
      </div>
      <FadeInZoom in={visible} className={menuClass}>
        <ul>
          {data.map((item, index) => {
            if (item.divider) {
              return <li key={index} className={`${prefixCls}-divider`} />;
            }
            return (
              <li
                key={index}
                className={`${prefixCls}-menu-item`}
                onClick={itemClick.bind(null, item)}
              >
                {item.icon ? <i className="bm-Icon">{item.icon}</i> : null}
                {item.title}
              </li>
            );
          })}
        </ul>
      </FadeInZoom>
    </div>
  );
}
